module.exports = __webpack_public_path__ + "static/media/vacuumTrailer.6dad2034.svg";